import React from 'react';
import './IconButton.scss';
export const IconButton = ({ type, label, small, focusOnly, disabled, onClick }) => {
    return (React.createElement("button", { className: "CSVImporter_IconButton", type: "button" // avoid triggering form submit
        , "aria-label": label, disabled: disabled, onClick: onClick, "data-small": !!small, "data-focus-only": !!focusOnly },
        React.createElement("span", { "data-type": type })));
};
